import WebsiteData from './WebsiteData';

export default WebsiteData;

